'use es6';

import { i18nWithNameSpace } from '../../utils/i18n';
export const contextualI18nKey = i18nWithNameSpace('TinymcePlugins.contextualToolbar');